import { render, staticRenderFns } from "./OnboardingDocumentUpload.vue?vue&type=template&id=931287d4&"
import script from "./OnboardingDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./OnboardingDocumentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports